module.exports = __webpack_public_path__ + "img/team-bg.46e3d704.jpeg";